import { render, staticRenderFns } from "./UserManagement.vue?vue&type=template&id=577bc258"
import script from "./user-management.ts?vue&type=script&lang=ts&external"
export * from "./user-management.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports